<div class="grid" *ngIf="carInformacionInicial">
  <div class="col-12 md:col-12 lg:col-12 text-center">
    <i class="fa fa-refresh fa-spin fa-3x fa-fw"></i><br>
    <span>{{'LBL_CONSULTANDO' | translate }}</span>
  </div>
</div>
<div *ngIf="!carInformacionInicial">
  <div class="grid">
    <div class="col-12 md:col-12 lg:col-12">
      <p-panel header="{{ 'CONTROLES.LBL_CONTROLES' | translate}}">
        <form [formGroup]="formulario" (ngSubmit)="onSubmit()" novalidate id="fControles" name="fControles">
          <div class="grid form-group">
            <div class="col-12 md:col-6 lg:col-6">
              <div class="div-form">
                <label>* {{ 'CONTROLES.LBL_CODIGO' | translate }}</label>
                <div *ngIf="!control">
                  <input type="text" pInputText id="codigo"
                         name="nomCodigo"
                         autocomplete="off"
                         formControlName="codigo"
                         maxlength="20"
                         (blur)="validarCodigo()"
                         codigos-reactive
                  >
                  <div class="p-message p-messages-error p-corner-all" *ngIf="submitted && f.codigo.invalid">
                    {{ 'CONTROLES.LBL_CODIGO' | translate}} {{ 'LBL_REQUERIDO' | translate}}
                  </div>
                  <div class="p-message p-messages-error p-corner-all" *ngIf="codExiste">
                    {{ 'MSG_CODIGOEXISTE' | translate}}
                  </div>
                </div>
                <div *ngIf="control && control.idControl">
                  <label class="falso-combo-texto">{{control.codigo}}</label>
                </div>
              </div>
            </div>
            <div class="col-12 md:col-6 lg:col-6">
              <div class="div-form">
                <label>* {{ 'CONTROLES.LBL_NOMBRE' | translate }}</label>
                <input type="text" pInputText id="nombre"
                       name="nomNombre"
                       autocomplete="off"
                       formControlName="nombre"
                       [maxlength]="50"
                       capitalize-reactive
                >
                <div class="p-message p-messages-error p-corner-all" *ngIf="submitted && f.nombre.invalid">
                  {{ 'CONTROLES.LBL_NOMBRE' | translate}} {{ 'LBL_REQUERIDO' | translate}}
                </div>
              </div>
            </div>
          </div>

          <div class="grid form-group">
            <div class="col-12 md:col-12 lg:col-12">
              <div class="div-form">
                <label>{{ 'CONTROLES.LBL_DESCRIPCION' | translate }}</label>
                <textarea id="idDescripcion" name="nomDescripcion" pInputTextarea rows="2"
                          capitalize-reactive maxlength="500"
                          formControlName="descripcion"></textarea>
              </div>
            </div>
          </div>


          <div class="grid">
            <div class="col-12 md:col-6 lg:col-6">
              <div class="div-form">
                <p-fieldset legend="{{ 'CONTROLES.LBL_COMPORTAMIENTO' | translate }}">
                  <div class="grid col-12">
                    <div class="col-12 md:col-6 lg:col-6">
                      <p-radioButton name="indicadorInterno" label="{{ 'CONTROLES.LBL_INTERNO' | translate}}"
                                     formControlName="indicadorInterno" (onClick)="cambioComportamiento()"
                                     [value]="true"></p-radioButton>
                    </div>
                    <div class="col-12 md:col-6 lg:col-6">
                      <p-radioButton name="indicadorInterno" label="{{ 'CONTROLES.LBL_EXTERNO' | translate}}"
                                     formControlName="indicadorInterno" (onClick)="cambioComportamiento()"
                                     [value]="false"></p-radioButton>
                    </div>
                  </div>
                </p-fieldset>
                <div class="p-message p-messages-error p-corner-all" *ngIf="submitted && f.indicadorInterno.invalid">
                  {{ 'CONTROLES.LBL_COMPORTAMIENTO' | translate}} {{ 'LBL_REQUERIDO' | translate}}
                </div>
              </div>
            </div>
            <div class="col-12 md:col-6 lg:col-6" *ngIf="f.indicadorInterno.value === false">
              <div class="div-form">
                <label>* {{ 'CONTROLES.LBL_URL' | translate }}</label>
                <input type="text" pInputText id="nomUrl"
                       name="nomUrl"
                       autocomplete="off"
                       formControlName="url"
                       [maxlength]="500"
                >
                <div class="p-message p-messages-error p-corner-all" *ngIf="submitted && f.url.invalid">
                  {{ 'CONTROLES.LBL_URL' | translate}} {{ 'LBL_REQUERIDO' | translate}}
                </div>
              </div>
            </div>
            <div class="col-12 md:col-6 lg:col-6" *ngIf="f.indicadorInterno.value === true">
              <div class="div-form">
                <p-checkbox label="{{ 'CONTROLES.LBL_INTEGRACION' | translate}}" binary="true"
                            id="indicadorIntegracion"
                            name="nomIndicadorIntegracion"
                            formControlName="indicadorIntegracion"></p-checkbox>
              </div>
            </div>
          </div>
          <div class="grid form-group">
            <div class="col-12 md:col-6 lg:col-6">
              <div class="div-form">
                <label>{{ 'CONTROLES.LBL_CAUSAL' | translate }}</label>
                <p-dropdown disableTab  id="idCausal" name="nomCausal" [options]="lisCausales"
                            placeholder="{{ 'LBL_SELECCIONE' | translate}}" emptyFilterMessage="{{ 'LBL_SINRESULTADOS' | translate}}"
                            emptyMessage="{{ 'LBL_SINRESULTADOS' | translate}}"
                            optionValue="value"
                            optionLabel="label"
                             formControlName="idCausal"
                ></p-dropdown>
                <div class="p-message p-messages-error p-corner-all" *ngIf="submitted && f.idCausal.invalid">
                  {{ 'CONTROLES.LBL_CAUSAL' | translate}} {{ 'LBL_REQUERIDO' | translate}}
                </div>
              </div>
            </div>
            <div class="col-12 md:col-6 lg:col-6">
              <p-checkbox label="{{ 'CONTROLES.LBL_REQUIEREADJUNTO' | translate}}" binary="true"
                          id="idRequiereAdjunto"
                          name="nomRequiereAdjunto"
                          formControlName="indicadorRequiereAdjunto"></p-checkbox>
            </div>
          </div>
          <div class="grid form-group">
            <div class="col-12 md:col-6 lg:col-6">
              <p-checkbox label="{{ 'LBL_HABILITADO' | translate}}" binary="true"
                          id="indicador"
                          name="nomIndicador"
                          formControlName="indicadorHabilitado"></p-checkbox>
            </div>
          </div>
          <div class="grid form-footer-buttons">
            <div class="form-group col-12">
              <div *ngIf="!guardando">
                <a (click)="regresar(formulario.dirty)" class="cancelar">{{'BTN_CANCELAR' | translate }}</a>
                <button icon="fa fa-floppy-o" label="{{'BTN_GUARDAR' | translate }}"
                      type="submit"
                      pButton></button>
              </div>
              <div *ngIf="guardando">
                <i class="fa fa-refresh fa-spin fa-2x fa-fw"></i><br>
                <span>{{'LBL_GUARDANDO' | translate }}</span>
              </div>
            </div>
          </div>
        </form>
      </p-panel>
    </div>
  </div>
</div>
<p-confirmDialog #cd>
  <ng-template pTemplate="footer">
    <button type="button" pButton icon="fa fa-close" label="{{ 'LBL_NO' | translate }}" (click)="cd.reject()"></button>
    <button type="button" pButton icon="fa fa-check" label="{{ 'LBL_SI' | translate }}" (click)="cd.accept()"></button>
  </ng-template>
</p-confirmDialog>
